var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("UiButton", {
              attrs: {
                variant: "secondary",
                buttonText: _vm.buttonText,
                fullWidth: "",
              },
              on: { click: _vm.showModal },
            }),
          ]
        },
        { showModal: _vm.showModal }
      ),
      _vm.modalShown
        ? _c("ProjectModal", {
            attrs: {
              data: _vm.project,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
            },
            on: {
              close: _vm.hideModal,
              projectUpdated: function ($event) {
                return _vm.$emit("projectUpdated")
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }